export default __webpack_public_path__ + "static/FritzphoneC4_02-30adca3e47073b00c859a8c35d7c39dd.webp";